console.log("Recommendation Engine Loaded");


/* ===================================================
   DETECT CUSTOMER REQUIREMENT
=================================================== */

function detectRequirement(message){

    message = message.toLowerCase();

    for(const key in RECOMMENDATION_RULES){

        for(const word of RECOMMENDATION_RULES[key]){

            if(message.includes(word)){

                return key;

            }

        }

    }

    return null;

}


/* ===================================================
   DETECT PRODUCT CATEGORY FROM CUSTOMER MESSAGE
=================================================== */

function detectCategory(message){

    message = message.toLowerCase();

    for(const category in PRODUCT_CATEGORIES){

        for(const keyword of PRODUCT_CATEGORIES[category]){

            if(message.includes(keyword)){

                return category;

            }

        }

    }

    return null;

}


/* ===================================================
   DETECT CATEGORY OF A SHOPIFY PRODUCT
=================================================== */

function getProductCategory(product){

    const text = (

        product.title +

        " " +

        (product.product_type || "") +

        " " +

        (product.tags || []).join(" ")

    ).toLowerCase();


    for(const category in PRODUCT_CATEGORIES){

        for(const keyword of PRODUCT_CATEGORIES[category]){

            if(text.includes(keyword.toLowerCase())){

                return category;

            }

        }

    }

    return "other";

}


/* ===================================================
   SCORE PRODUCT
=================================================== */

function scoreProduct(product,message){

    let score = 0;

    const requirement = detectRequirement(message);

    const category = detectCategory(message);

    const title = product.title.toLowerCase();

    const tags = (product.tags || []).join(" ").toLowerCase();

    const type = (product.product_type || "").toLowerCase();



    /* CATEGORY SCORE */

    if(category){

        if(getProductCategory(product)==category){

            score += 50;

        }

    }



    /* REQUIREMENT SCORE */

    if(requirement=="home"){

        if(

            tags.includes("home") ||

            tags.includes("indoor") ||

            title.includes("indoor")

        ){

            score += 30;

        }

    }



    if(requirement=="shop"){

        if(

            tags.includes("shop") ||

            tags.includes("commercial") ||

            tags.includes("outdoor") ||

            title.includes("outdoor")

        ){

            score += 30;

        }

    }



    if(requirement=="office"){

        if(

            tags.includes("office") ||

            tags.includes("fingerprint") ||

            title.includes("office")

        ){

            score += 30;

        }

    }



    if(requirement=="warehouse"){

        if(

            tags.includes("warehouse") ||

            tags.includes("outdoor")

        ){

            score += 30;

        }

    }



    if(requirement=="factory"){

        if(

            tags.includes("factory") ||

            tags.includes("industrial")

        ){

            score += 30;

        }

    }



    /* BONUS */

    if(type.includes(category || "")){

        score += 10;

    }

    return score;

}



/* ===================================================
   MAIN RECOMMENDATION ENGINE
=================================================== */

function recommendProducts(message){

    const results = [];

    ALL_PRODUCTS.forEach(product=>{

        const score = scoreProduct(product,message);

        if(score>0){

            results.push({

                product,

                score

            });

        }

    });



    results.sort(function(a,b){

        return b.score-a.score;

    });



    return results;

}



/* ===================================================
   RETURN TOP PRODUCTS
=================================================== */

function getTopRecommendations(message,limit=3){

    return recommendProducts(message)

            .slice(0,limit)

            .map(item=>item.product);

}



/* ===================================================
   DEBUG FUNCTION
=================================================== */

window.testRecommendation=function(message){

    console.clear();

    console.log("MESSAGE :",message);

    console.log("REQUIREMENT :",detectRequirement(message));

    console.log("CATEGORY :",detectCategory(message));



    const products=getTopRecommendations(message,5);



    console.log("TOP PRODUCTS");



    products.forEach(function(product,index){

        console.log(

            (index+1),

            product.title

        );

    });

}